<template>
  <div>
    <div class="item-box-content-table">
      <el-row>
        <el-col :span="12">
          <div class="title-font-style">
            <span>基本信息</span>
          </div>
        </el-col>
      </el-row>
      <el-form
        style="padding:20px 30px 0 30px"
        class="details-line-height"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="付款编号：">{{params.receiptNumber}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款类型：">{{'银行转账'}}</el-form-item>
          </el-col>
          <el-col
            :span="12"
            style="padding-bottom:0;"
          >
            <el-form-item label="付款金额：">{{params.receiprMoney |priceFilterNum}}</el-form-item>
          </el-col>

          <el-col
            :span="12"
            style="padding-bottom:0;"
          >
            <el-form-item label="备注：">{{params.mark}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div :class="state=== '退回修改'?'item-box-content':'item-box-content-table'">
      <div class="title-font-style">
        <span>账户信息</span>
      </div>
      <el-form
        v-if="isShow"
        style="padding:20px 30px 0 30px"
        class="details-line-height"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="账户名称：">{{params.receiptName}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行账号：">{{params.receiptBankNumber }}</el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开户银行：">{{params.receiptOpenBank}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行行号：">{{params.receiptOpenNumber}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form
        v-if="!isShow"
        label-width="100px"
        style="margin-top:20px;"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="账户名称：">
              {{params.receiptName}}
              <el-button
                type="text"
                @click="onAddAccount"
                style="margin-left:10px"
              >
                <i class="el-icon-plus"></i>添加账户
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行账号：">
              <el-select
                @change="changeBank"
                v-model.trim="params.receiptBankNumber"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,index) in contractScreenCondition"
                  :key="index"
                  :label="item.bankCode"
                  :value="item.bankCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开户银行：">
              <el-input
                disabled
                v-model.trim="params.receiptOpenBank"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行行号：">
              <el-input
                disabled
                v-model.trim="params.receiptOpenNumber"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="state ==='退回修改'">
        <el-button
          v-if="isShow"
          @click="edit"
          style="margin-left:20px;"
        >修改
        </el-button>
        <el-button
          v-if="!isShow"
          @click="save"
          type="primary"
          style="margin-left:20px;"
        >提交
        </el-button>
      </div>
    </div>
    <div class="item-box-content-table">
      <div class="title-font-style">
        <span>付款信息</span>
      </div>
      <el-form
        style="padding:20px 30px 0 30px"
        class="details-line-height"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="付款方式：">{{'银行转账'}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款金额：">{{params.receiprMoney|priceFilterNum}}</el-form-item>
          </el-col>
          <el-col
            :span="24"
            v-if="state ==='付款成功'"
          >
            <el-form-item
              label="付款账户："
            >{{(params.receiptName || '')+' '+(params.receiptOpenBank||'')+' '+(params.receiptBankNumber||'')}}
            </el-form-item>
          </el-col>
          <el-col
            :span="24"
            v-if="state ==='付款成功'"
          >
            <el-form-item label="备注：">{{params.paymentDetailsAllAccountVoList[0].mark}}</el-form-item>
          </el-col>

          <el-col
            :span="12"
            v-if="state ==='审批不通过'"
          >
            <el-form-item label="付款状态：">
              <span style="color:##c3706d;">{{'审批不通过'}}</span>
            </el-form-item>
          </el-col>
          <el-col
            :span="12"
            v-if="state ==='退回修改'"
          >
            <el-form-item label="付款状态：">
              <span style="color:#c3706d;">{{'退回修改'}}</span>
            </el-form-item>
          </el-col>
          <el-col
            :span="12"
            v-if="state ==='付款成功'"
          >
            <el-form-item label="付款状态：">
              <span style="color:#85c28e;">{{'付款成功'}}</span>
            </el-form-item>
          </el-col>
          <el-col
            :span="12"
            v-if="state ==='付款审批'"
          >
            <el-form-item label="付款状态：">
              <span style="color:#e38545;">{{'付款审批'}}</span>
            </el-form-item>
          </el-col>

          <el-col
            :span="12"
            v-if="state !=='付款审批'"
          >
            <el-form-item label="处理人：">{{params.paymentDetailsAllAccountVoList[0].processUser}}</el-form-item>
          </el-col>
          <el-col
            :span="12"
            v-if="state !=='付款审批'"
          >
            <el-form-item label="处理时间：">{{params.paymentDetailsAllAccountVoList[0].processDate}}</el-form-item>
          </el-col>
          <el-col
            :span="12"
            v-if="state !=='付款成功'&& state !=='付款审批'"
          >
            <el-form-item label="备注：">{{params.paymentDetailsAllAccountVoList[0].mark}}</el-form-item>
          </el-col>
          <el-col
            :span="12"
            v-if="state ==='付款成功'"
          >
            <el-form-item label="付款凭证：" >
              <el-row :gutter="20" v-if="params.paymentDetailsAllAccountVoList[0].attachment">
                <el-col :span="4">
                  <span
                    @click="onSee(params.paymentDetailsAllAccountVoList[0].attachment)"
                    class="approval"
                  >查看</span>
                </el-col>
                <el-col :span="4">
                  <span
                    @click="onDownload(params.paymentDetailsAllAccountVoList[0].attachment)"
                    class="approval"
                  >下载</span>
                </el-col>
              </el-row>
              <div v-else>--</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <add-bank-account-dialog
      @addAccountDialog="addAccountDialog"
      ref="addBankAccountDialogRefs"
    ></add-bank-account-dialog>
    <!-------------- 查看资格证书 -------------->
    <brand-dialog
      ref="brandDialogRef"
      :title="`查看凭证`"
    ></brand-dialog>
  </div>
</template>
<script>
import { financeUploadFile } from '@/api/fiance/fianceManage'
import addBankAccountDialog from '@/components/AddAccount/addAccountDialog'
import {
  queryBySuId, addRetreatReceipt, queryPaymentDetails, updatePayment
} from '@/api/purchase/purchasePlanList'
import noticeApi from '@/api/workbench/notice'
import { downLoadFile, isSuccess } from '@/util/tool'
import BrandDialog from '@/views/crm/components/supplier/dialog/brandDialog'
import { download } from '@/api/sell/sellManage'
import checkApi from '@/api/workbench/check'

export default {
  components: {
    'add-bank-account-dialog': addBankAccountDialog,
    BrandDialog
  },

  data () {
    return {
      state: '退回修改',
      suId: '',
      contractScreenCondition: [],
      queryParams: {},
      isShow: true,
      fileList: [],
      suNameList: {},
      params: {
        mark: '',
        payeeType: 1,
        paymentDetailsAllAccountVoList: [
          {
            paymentNumber: null,
            amount: 0,
            state: '付款审批',
            attachment: null,
            mark: null,
            processUser: null
          }],
        receiprMoney: 1,
        receiptBankNumber: '',
        receiptName: '',
        receiptNumber: 'FK--0001',
        receiptOpenBank: '',
        receiptOpenNumber: null,
        receiptType: ''

      }
    }
  },
  methods: {
    edit () {
      this.isShow = false
    },
    save () {
      updatePayment(this.params.receiptNumber, this.params).then(res => {
        if (isSuccess(res)) {
          this.isShow = true
          this.$message.success(res.data.msg)
          location.reload()
        }
      })
    },
    // radio change
    payeeTypeChange () {

    },
    onSubmit () {
      if (this.fileList.length === 1) {
        this.params.billAttachment = this.fileList[0].id
      }
      this.params.receiptType = this.receiptType
      this.params.pcrsId = this.pcrsId
      this.params.billCompany = this.suNameList.suName
      this.params.receiptName = this.suNameList.suName
      if (this.params.mark === '') {
        this.$message.error('备注不能为空!')
      } else if (this.params.payeeType === 1 && this.params.receiptBankNumber === '') {
        this.$message.error('请选择银行账号!')
      } else {
        addRetreatReceipt(this.params)
          .then((res) => {
            if (res.data.code === 200) {
              this.$emit('getList')
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    getList (type) {
      queryPaymentDetails(type).then((res) => {
        if (res.data.code === 200) {
          this.params = res.data.obj.paymentDetailsAllVo
          this.state = this.params.paymentDetailsAllAccountVoList[0].state
          this.suId = res.data.obj.purchaseRetreatVo.suId
          queryBySuId(this.suId)
            .then((res) => {
              if (res.data.code === 200) {
                this.contractScreenCondition = res.data.obj
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else {
          this.$message.error(res.data.msg)
        }
      })
        .catch((err) => {
          console.log(err)
        })
    },
    // 添加账户
    onAddAccount () {
      const { suId: cusId, params } = this
      const obj = {
        cusId,
        suName: params.receiptName
      }
      this.$refs.addBankAccountDialogRefs.onInitial(obj)
    },
    // 下载文件
    downloadFile (guid) {
      noticeApi
        .downloadNoticeFile({
          guid
        })
        .then((res) => {
          downLoadFile(res)
        })
    },
    // 查看
    onSee (attachment) {
      checkApi.getPactFileUrl({ guid: attachment }).then(res => {
        if (isSuccess(res)) {
          const { filePath } = res.data.obj
          if (filePath) {
            const file = filePath.split('.')
            const fileType = file[file.length - 1]
            this.$refs.brandDialogRef.onBlackDialog([{
              filePath,
              fileExt: '.' + fileType
            }])
          }
        }
      })
      // this.$refs.brandDialogRef.onBlackDialog(attachment)
    },
    onDownload(guid) {
      download(guid)
        .then(res => {
          if (res.data.code === 200) {
            downLoadFile(res)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    // 银行账户change
    changeBank () {
      this.contractScreenCondition.forEach((element) => {
        if (element.bankCode === this.params.receiptBankNumber) {
          this.params.receiptOpenBank = element.bankOpencount
          this.params.receiptOpenNumber = element.bankOpenCode
          this.params.receiptBankId = element.id
        }
      })
    },
    // 请求银行账户
    bankList () {
      queryBySuId(this.suId)
        .then((res) => {
          if (res.data.code === 200) {
            this.contractScreenCondition = res.data.obj
            this.params.receiptBankNumber = this.contractScreenCondition[this.contractScreenCondition.length - 1].bankCode
            this.changeBank()
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    addAccountDialog () {
      this.bankList()
    },
    async allUpload () {
      var formData = new FormData()
      const { fileList } = this
      const len = fileList.length - 1
      formData.append('MultipartFile[]', fileList[len].raw)
      await financeUploadFile(formData).then((res) => {
        if (res.data.code === 200) {
          this.ruleForm.push(...res.data.obj)
          Object.assign(this.fileList[len], {
            id: res.data.obj[0].guid
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    beforeUploadFile (file) {
      const { uploadFileType } = this
      const filearr = file.name.split('.')
      const filetype = filearr[filearr.length - 1]
      if (file.size === 0) {
        this.$message.error('文件内容为空')
        return false
      } else if (file.size > 1024 * 1024 * 10) {
        this.$message.error('文件过大')
        return false
      } else if (uploadFileType.includes(filetype)) {
        return true
      }
      this.$message.error('请上传正确的文件')
      return false
    },
    handleChange (file, fileList) {
      this.fileList = fileList
    }
  }
}
</script>
